var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('h1',[_vm._v("Component 5")]),_c('v-alert',{staticStyle:{"position":"absolute"},attrs:{"type":"success","width":"fit-content"}},[_vm._v(" Old gui iframe test.")]),_c('iframe',{staticStyle:{"width":"100%","height":"80vh"},attrs:{"id":"iframe_oldgui","src":_vm.GenerateURL()}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }